import { render, staticRenderFns } from "./WizardResultPage.vue?vue&type=template&id=6cf49a59&scoped=true&"
import script from "./WizardResultPage.vue?vue&type=script&lang=js&"
export * from "./WizardResultPage.vue?vue&type=script&lang=js&"
import style0 from "./WizardResultPage.vue?vue&type=style&index=0&id=6cf49a59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf49a59",
  null
  
)

export default component.exports